import React from 'react';
import { Tabs, Tooltip, Icon } from 'antd';
import {dataTable} from '../utils/utils';
import {chartOptions, chartData} from '../chart/config';
import {data_items_detail} from '../data/csv';
import DetailTable from './DetailTable';
import AboutVariable from './AboutVariable';
import Summary from './Summary';
import numeral from 'numeral';
import ChartRenderProp from './ChartRenderProp';
import { HorizontalBar } from 'react-chartjs-2';
const TabPane = Tabs.TabPane;
import {getFormatTotal, getTotalOfObject, getPercentageOfObject, mergeObjectToArray, setUpColumnObject, 
  sortDesByValue, replaceDbValuesForTable, filterByCategory} from '../utils/utils';
import { groupReturnedObject} from '../chart/config';

const DetailTabs = (props) => {
  let content, detailTable, summary, aboutVariable, show_tab_summary, show_tab_chart, show_tab_table, show_tab_about;
    if (props.data.detailChartData.length === 0) {
      content = <h3>No Item</h3>
      detailTable = <h3>No Item</h3>
    } else {
        const data_table = {...props.data.data_table}
        show_tab_summary = data_table.show_tab_summary === 1 || data_table.show_tab_summary === true
        show_tab_chart = data_table.show_tab_chart === 1 || data_table.show_tab_chart === true
        show_tab_table = data_table.show_tab_table === 1 || data_table.show_tab_table === true
        show_tab_about = data_table.show_tab_about === 1 || data_table.show_tab_about === true
        //console.log('show', show_tab_summary,show_tab_chart, show_tab_table, show_tab_about  )
        //console.log('comparisionData data', this.props.comparisionData)
        const groupByGeoname = groupReturnedObject(props.data.comparisionData, 'geo_name','category', true)
        //console.log('groupByGeoname', groupByGeoname)
        const totalObject = getTotalOfObject(groupByGeoname)
        //console.log('totalObject', totalObject)

        const percentageObj = getPercentageOfObject(groupByGeoname, totalObject)
        //console.log('percentageObj', percentageObj)
        const initData = getFormatTotal(props.data.detailTableData, props.data.categoryTotal.total);
        //console.log('initData', initData)
        const dataMergedForTable = mergeObjectToArray(percentageObj, initData)
        //console.log('dataMergedForTable', dataMergedForTable)

        let dataForSummary
        if(data_table.summary_sort === 1 || data_table.summary_sort === true) {
          dataForSummary = sortDesByValue(dataMergedForTable, 'total')
        } else {
          dataForSummary = dataMergedForTable
        }
        //console.log('dataForSummary', dataForSummary)
        // Summary tab
        const dataFilteredForSummary = filterByCategory(dataForSummary, {category: 'Not Stated'})
        //console.log('dataFilteredForSummary', dataFilteredForSummary)
        const summaryContent = replaceDbValuesForTable(props.data, dataFilteredForSummary, Object.keys(percentageObj))
        const summaryHeader = `${data_table.summary_heading} - ${props.data.geo_name}`
        summary = <Summary 
        summaryHeader = {summaryHeader}
        summaryContent = {summaryContent} />

        // Chart Tab
        const horizontalBarData = chartData(props.data.detailChartData.slice(0, data_items_detail), 'category', props.data.categoryTotal.total, 'population')
        content = <ChartRenderProp 
        tableName={data_table.chart_heading} 
        header = { () => ( 
          <div>{data_table.chart_heading} - {props.data.detailChartData[0].geo_name}</div>
         )}
         
        render = { (setRef) => (
          <HorizontalBar download={true} redraw={true} 
          data={horizontalBarData} 
          width={600}
          height={500} 
          options={chartOptions} 
          ref= {setRef}
          ></HorizontalBar>
        )} />

        // Table Tab
        detailTable =   <DetailTable 
        dataMergedForTable= {dataMergedForTable}
        percentageObj= {percentageObj}
        data={props.data.detailTableData} 
        geo_name={props.data.geo_name}
        data_table={data_table}
        population={props.data.population} />

        // About this variable tab
        aboutVariable = <AboutVariable data={props.data} />
    }
    return (
      <div className="card-container">
      <Tabs type="card">
        {show_tab_summary && <TabPane tab={<span>Summary 
          <Tooltip title="A quick overview of some of the key features of this variable">
          <Icon type="question-circle"/>
          </Tooltip></span>} key="1">
          {summary} 
        </TabPane>}
        {show_tab_chart && <TabPane tab={<span>Chart 
          <Tooltip title="View and download the data in chart form">
          <Icon type="question-circle" />
          </Tooltip></span>} key="2">
          {content}
        </TabPane>}
        {show_tab_table && <TabPane tab={<span>Table 
          <Tooltip title="View and download the data in tabular form">
          <Icon type="question-circle"/>
          </Tooltip></span>} key="3">
          <div className="download">
            {detailTable}
          </div>
        </TabPane>} 
        {show_tab_about && <TabPane tab={<span>About this variable 
          <Tooltip title="Information on how this data has been collected and what it means">
          <Icon type="question-circle" />
          </Tooltip></span>} key="4">
          {aboutVariable}
        </TabPane>}
      </Tabs>
  </div>
    )
  
}
export default DetailTabs;



// WEBPACK FOOTER //
// ./src/components/DetailTabs.js